import { AlertTriangle, RotateCcw, X } from 'lucide-react';

interface GenerationFailedNoticeProps {
  /** Message renvoyé par le serveur (il explique déjà que l'élève n'y est pour rien). */
  message: string;
  /** Le titre en gras ; par défaut, celui d'un exercice. */
  title?: string;
  onRetry: () => void;
  /** Sans lui, pas de croix (rien d'autre à afficher à la place, comme une question d'Entraînement IA). */
  onDismiss?: () => void;
  /** Marges selon l'emplacement (sous les boutons de la correction, ou au-dessus de l'éditeur). */
  className?: string;
}

/**
 * Bandeau affiché sous le bouton qui a demandé un exercice (« Même niveau, autre situation »,
 * « Augmenter la difficulté », « Connaissance suivante », « Me défier sur ce point » de l'examen blanc)
 * quand sa création échoue. L'élève garde la page sous les yeux et relance la même demande d'un clic.
 */
export function GenerationFailedNotice({ message, title = 'La création de l\'exercice a échoué', onRetry, onDismiss, className = 'mt-3' }: GenerationFailedNoticeProps) {
  return (
    <div
      role="alert"
      className={`${className} flex items-start gap-3 rounded-lg border border-amber-300 dark:border-amber-700 bg-amber-50 dark:bg-amber-900/20 px-4 py-3 text-sm text-amber-900 dark:text-amber-100`}
    >
      <AlertTriangle className="w-5 h-5 mt-0.5 flex-shrink-0 text-amber-500 dark:text-amber-400" aria-hidden="true" />
      <div className="flex-1 min-w-0">
        <p className="font-semibold">{title}</p>
        <p className="mt-1">{message}</p>
        <button
          type="button"
          onClick={onRetry}
          className="mt-2 inline-flex items-center px-3 py-1.5 bg-amber-600 hover:bg-amber-700 text-white text-sm font-medium rounded-md transition-colors"
        >
          <RotateCcw className="w-4 h-4 mr-1" aria-hidden="true" />
          Réessayer
        </button>
      </div>
      {onDismiss && (
      <button
        type="button"
        onClick={onDismiss}
        className="p-1 text-amber-500 hover:text-amber-700 dark:text-amber-400 dark:hover:text-amber-200 rounded transition-colors"
        aria-label="Fermer ce message"
      >
        <X className="w-4 h-4" />
      </button>
      )}
    </div>
  );
}
